module.exports = __webpack_public_path__ + "Assets/3071ab8f-494f-44e7-919c-4c46e8d45cbc.svg";